import { apiMain } from './config/axios';
import { store } from '../store';

const getConfig = () => {
  const { token } = store.getState().auth;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

/**
 * Fetch all subscriptions owned by the authenticated user
 */
export const getSubscriptions = () => apiMain.get('/api/v1/subscriptions', {}, getConfig());

/**
 * Fetch all subscriptions for a specific app
 * @param {string} appId
 */
export const getAppSubscriptions = (appId) => apiMain.get(`/api/v1/subscriptions/app/${appId}`, {}, getConfig());

/**
 * Fetch all available subscription products
 */
export const getProducts = () => apiMain.get('/api/v1/subscriptions/products', {}, getConfig());

/**
 * Fetch all invoices owned by the authenticated user
 */
export const getInvoices = () => apiMain.get('/api/v1/subscriptions/invoices', {}, getConfig());

/**
 * Create a new subscription (initiates a pending-payment state)
 * @param {Object} data - { productId, appId, metadata }
 */
export const createSubscription = (data) => apiMain.post('/api/v1/subscriptions', data, getConfig());

/**
 * Renew an active or expired subscription using the wallet balance
 * @param {string} subId - Subscription ID
 */
export const renewSubscription = (subId, data = {}) => apiMain.post(`/api/v1/subscriptions/${subId}/renew`, data, getConfig());

/**
 * Initialize a Paystack transaction for renewal
 * @param {string} subId
 * @param {Object} data - { months, couponCode, callbackUrl }
 */
export const initializePaystackPayment = (subId, data) => apiMain.post(`/api/v1/subscriptions/${subId}/paystack/initialize`, data, getConfig());

/**
 * Verify a completed Paystack transaction reference
 * @param {Object} data - { reference }
 */
export const verifyPaystackPayment = (data) => apiMain.post('/api/v1/subscriptions/paystack/verify', data, getConfig());

